import { render, staticRenderFns } from "./CreatePromoModal.vue?vue&type=template&id=2d871665&scoped=true"
import script from "./CreatePromoModal.vue?vue&type=script&lang=js"
export * from "./CreatePromoModal.vue?vue&type=script&lang=js"
import style0 from "./CreatePromoModal.vue?vue&type=style&index=0&id=2d871665&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d871665",
  null
  
)

export default component.exports